import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

import success from '../../assets/success.svg'
import satisfaction from '../../assets/satisfaction.svg'
import clients from '../../assets/clients.svg'
import { useNavigate } from 'react-router-dom';
import StatisticsHeader from './StatisticsHeader';


const Statistics = () => {
    const data = [
        {
            title: 'Successfully Completed Projects',
            duration: 100,
            sign: '+',
            img: success
        },
        {
            title: "Satisfied Client's",
            duration: 100,
            sign: '+',
            img: satisfaction
        },
        {
            title: 'Client Satisfaction Rate',
            duration: 98,
            sign: '%',
            img: clients
        }
    ];

    const navigate = useNavigate()

    const handleClick = (index) => {
        if (index > 0) {
            navigate('/#review')
        }
    }

    return (
        <div className="max-w-screen-xl mx-auto px-5 py-6 md:py-10 ">
            <p className="text-2xl font-bold text-center dark:text-white">
                Let Us Know What You’re Looking for,
                <br />
                <span className="text-red-500">We’ll Build it for You</span>
            </p>

            <StatisticsHeader />

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 my-5 md:my-16">
                {data.map((item, i) => (
                    <div className="group" key={i}>
                        <div
                            className={`shadow-md px-2 py-3 md:py-5 cursor-pointer rounded-xl md:group-hover:scale-105 duration-700 ${i === 0 ? 'bg-red-400' : i === 1 ? 'bg-gray-700' : 'bg-yellow-600'
                                }`}
                            onClick={() => handleClick(i)}
                        >
                            <div className='flex justify-center'>
                                <img src={item.img} alt="img" className='h-[60px] md:h-[80px] w-[60px] md:w-[80px] mb-3 group-hover:animate-bounce-2' />
                            </div>
                            <h1 className="font-bold text-xs md:text-sm text-center text-white">{item.title}</h1>
                            <div className="flex items-center justify-center">
                                <VisibilitySensor partialVisibility offset={{ bottom: 100 }}>
                                    {({ isVisible }) => (
                                        <div className="font-bold flex items-center text-center text-2xl md:text-3xl text-white py-1 px-4 rounded-md">
                                            {isVisible ? <CountUp end={item.duration} /> : (
                                                <span>{item.duration}</span>
                                            )}
                                            <p className="font-bold text-center text-white ">
                                                <span>{item.sign}</span>
                                            </p>
                                        </div>
                                    )}
                                </VisibilitySensor>

                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Statistics;